import { WalletLogTab } from "../../../../hooks/use-wallet-tab";
import { useWalletContext } from "../../../../hooks/wallet-context";
import { useWalletLogContext } from "../../../../hooks/wallet-log-context";
import WalletLogsMileageList from "./components/mileage";
import WalletLogsPointList from "./components/point";
import WalletLogsSeedList from "./components/seed";
import WalletLogsSubPrizeList from "./components/sub-prize";
import WalletLogsListSkeleton from "./skeleton";
import { WalletLogsListWrapper } from "./style";

const WalletLogsList = () => {
  const { isLogTab } = useWalletContext();
  const { loading } = useWalletLogContext();

  if (loading) return <WalletLogsListSkeleton />;

  return (
    <WalletLogsListWrapper>
      {isLogTab(WalletLogTab.SEED) ? (
        <WalletLogsSeedList />
      ) : isLogTab(WalletLogTab.POINT) ? (
        <WalletLogsPointList />
      ) : isLogTab(WalletLogTab.MILEAGE) ? (
        <WalletLogsMileageList />
      ) : (
        <WalletLogsSubPrizeList />
      )}
    </WalletLogsListWrapper>
  );
};

export default WalletLogsList;
